

<template>
    <div class="main-container container-fluid">
        <ul class="nav nav-tabs" id="myTab" role="tablist">
            <li class="nav-item" role="presentation">
                <button @click="getData()" class="nav-link active" id="home-tab" data-bs-toggle="tab" type="button" role="tab" aria-selected="true">Aktyvūs</button>
            </li>
            <li class="nav-item" role="presentation">
                <button @click="getData('https://varzytiniuzemelapis.lt/wp-json/auctions/v1/done')" class="nav-link" id="profile-tab" data-bs-toggle="tab" d type="button" role="tab"  aria-selected="false">Baigti</button>
            </li>
        </ul>
        <div class="row">
            <div class="col-md-12">
                <GoogleMap :center="center" :zoom="8" api-key="AIzaSyDy9g0EM4e-6YgEvEtGLtnuNvqiUU8sOX4" style="width: 100%; height: calc(100vh - 152px);" @click="handleInfoWindowClose"
                    ref="myMapRef"  mapId="myMapRef">
                   
                    <InfoWindow v-if="infoWindowOpened" :options="{ position: infoWindowPosition, pixelOffset: {width: 0,height: -35,}, headerDisabled: false,isOpen: false }" :isOpen="false"
                        :closeclick="true" :click="true" @closeclick="handleInfoWindowClose">
                        <div class="info-window">
                            <div class="container g-2">
                                <div class="row g-2 align-items-center">
                                    <div class="col-12 col-md-11">
                                        <div class="text-start">
                                            <div class="row">
                                                <div class="col-11">
                                                    <h5 class="text-uppercase">
                                                        {{ activeEstate.name }} (Nr. {{ activeEstate.auction_number }})
                                                    </h5>
                                                    {{ activeEstate.acution_type }}
                                                </div>
                                                <div class="col-12">
                                                    {{ activeEstate.subtype }} {{ activeEstate.size }}
                                                    {{ activeEstate.part }}
                                                    <span v-if="
                                                        activeEstate.sizea != '0' &&
                                                        activeEstate.part != '1/1'
                                                    ">({{ activeEstate.sizea }} {{ activeEstate.size_unit }})</span>
                                                    {{ activeEstate.status }}
                                                </div>
                                                <div class="col-12">
                                                    {{ activeEstate.descr_formated }}
                                                </div>
                                                <div v-if="activeEstate.address != ''" class="col-12 pt-2">
                                                    {{ activeEstate.address }}
                                                </div>
                                                <div class="text-start">
                                                    {{ activeEstate.start_date_formated }}/{{
                                                        activeEstate.end_date_formated
                                                    }}
                                                </div>
                                                <div class="col-12 pt-1 pl-3">
                                                    <a style="padding-right: 10px" v-bind:href="
                                                        'https://www.evarzytynes.lt' + activeEstate.link
                                                    " target="_blank">Varžytinės</a>
                                                    <a style="padding-right: 10px" v-if="activeEstate.lt_lng != ''"
                                                        v-bind:href="
                                                            'https://regia.lt/map/regia2?x=' +
                                                            activeEstate.lt_lng +
                                                            '&y=' +
                                                            activeEstate.lt_lat +
                                                            '&scale=1000&identify=true&sluo_ids=22'
                                                        " target="_blank">Regia</a>
                                                    <a style="padding-right: 10px" v-if="activeEstate.lt_lng != ''"
                                                        v-bind:href="
                                                            '  https://www.geoportal.lt/map/#s=3346&x=' +
                                                            activeEstate.lt_lng +
                                                            '&y=' +
                                                            activeEstate.lt_lat +
                                                            '&l=12&b=default'
                                                        " target="_blank">Geoportal</a>
                                                    (Atnaujinta {{ activeEstate.updated }})
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-12 col-md-11">
                                        <div class="price text-center mt-3">
                                            <h5>
                                                <b>{{ activeEstate.start_bid }}</b>€<span
                                                    v-if="activeEstate.current_bid != '0'">({{ activeEstate.current_bid
                                                    }}€)</span>
                                            </h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                </InfoWindow>
                <!-- <GMapCluster
                        :gridSize="30"
                        :zoomOnClick="true"
                        :enableRetinaIcons="true"
                        :minimumClusterSize="3"
                            :maxZoom="20"
                            ref="cluster" >-->
                    <!--<Marker v-for="r in autocomplete" :key="r.estate_id" :position="getPosition(r)" :clickable="true"
                        :draggable="false" @click="handleMarkerClicked(r)"></Marker>-->
                   <!-- eslint-disable -->
                    <Marker v-for="r in maplist" :options="{position: getPosition(r)}" :key="r.estate_id" :clickable="true"
                    :draggable="false" @click="handleMarkerClicked(r)"></Marker>
                    <Polygon :options="{paths: getPoli(activeEstate),  strokeWeight: 2, fillOpacity: 0.1}" />
                <!-- eslint-enable -->    
                <!--</GMapCluster>-->
                </GoogleMap>
            </div>

            <!--New layout-->

            <!-- BEGIN SEARCH RESULT -->
            <div class="col-md-12">
                <div class="grid search">
                    <div class="grid-body">
                        <div class="row">
                            <!-- BEGIN FILTERS -->
                            <div class="col-md-3">
                                <div class="d-flex flex-row">
                                    <h3 role="button" class="grid-title col-10" data-bs-toggle="collapse"
                                        data-bs-target="#filterall" aria-expanded="false" aria-controls="filterall">
                                        <i class="fa fa-filter"></i> Filtrai
                                        <i class="fa fa-caret-down"></i>
                                    </h3>
                                    <div class="col-1"></div>
                                    <h3 title="Išvalyti" @click="clearFilter" role="button" class="pe-3 col-1">
                                        <i class="fa fa-times"></i>
                                    </h3>
                                </div>
                                <hr />
                                <div class="collapse" id="filterall" :class="{ show: deviceType != 'mobile'  }">
                                    <!-- BEGIN FILTER BY CATEGORY -->

                                    <div class="filter_list">
                                        <h4 role="button" data-bs-toggle="collapse" data-bs-target="#filterkaina"
                                            aria-expanded="true" aria-controls="filterkaina">
                                            Kaina <i class="fa fa-caret-down"></i>
                                        </h4>
                                        <div class="collapse" id="filterkaina" :class="{ show: deviceType != 'mobile' }">
                                            <FilterInput title="Pradinė kaina nuo" type="number" v-model="start_bid_from" />
                                            <FilterInput title="Pradinė kaina iki" type="number" v-model="start_bid_to" />
                                        </div>
                                        <hr />
                                        <h4 role="button" data-bs-toggle="collapse" data-bs-target="#filtertekstas"
                                            aria-expanded="true" aria-controls="filtertekstas">
                                            Tekstas <i class="fa fa-caret-down"></i>
                                        </h4>
                                        <div class="collapse" id="filtertekstas" :class="{ show: deviceType != 'mobile' }">
                                            <FilterInput title="Aprašymas" type="text" v-model="descr" />
                                            <FilterInput title="Adresas" type="text" v-model="address" />
                                        </div>
                                        <hr />
                                        <h4 role="button" data-bs-toggle="collapse" data-bs-target="#filterturtas"
                                            aria-expanded="true" aria-controls="filterturtas">
                                            Turtas <i class="fa fa-caret-down"></i>
                                        </h4>
                                        <div class="collapse" id="filterturtas" :class="{ show: deviceType != 'mobile' }">
                                            <FilterMultiselectInput title="Turto tipas" label="subtype" v-model="subtype" />
                                            <FilterMultiselectInput title="Turto pavadinimas" label="name" v-model="name" />
                                        </div>
                                        <hr />
                                        <h4 role="button" data-bs-toggle="collapse" data-bs-target="#filterauct"
                                            aria-expanded="true" aria-controls="filterauct">
                                            Varžytinės <i class="fa fa-caret-down"></i>
                                        </h4>
                                        <div class="collapse" id="filterauct" :class="{ show: deviceType != 'mobile' }">
                                            <FilterMultiselectInput title="Varžytinių tipas" label="acution_type"
                                                v-model="acution_type" />
                                            <FilterMultiselectInput title="Varžytinių subtipas" label="auction_subtype"
                                                v-model="auction_subtype" />
                                            <FilterMultiselectInput title="Būsena" label="status" v-model="status" />
                                            <FilterInput title="Varžytinių numeris" type="number" v-model="auction_number" />
                                        </div>
                                        <hr />
                                        <h4 role="button" data-bs-toggle="collapse" data-bs-target="#filterdata"
                                            aria-expanded="true" aria-controls="filterdata">
                                            Datos <i class="fa fa-caret-down"></i>
                                        </h4>
                                        <div class="collapse" id="filterdata" :class="{ show: deviceType != 'mobile' }">
                                            <FilterDatePickerInput title="Pradžia" range="true" v-model="PradziaNuoIki" />
                                            <FilterDatePickerInput title="Pabaiga" range="true" v-model="PabaigaNuoIki" />
                                            <FilterDatePickerInput title="Sukurta" range="false" v-model="created" />
                                        </div>
                                        <hr />
                                        <h4 role="button" data-bs-toggle="collapse" data-bs-target="#filterkita"
                                            aria-expanded="true" aria-controls="filterkita">
                                            Kita <i class="fa fa-caret-down"></i>
                                        </h4>
                                        <div class="collapse" id="filterkita" :class="{ show: deviceType != 'mobile' }">
                                            <FilterMultiselectInput title="Dalis" label="part" v-model="part" />
                                            <FilterMultiselectInput title="Dydžio vnt." label="size_unit" v-model="size_unit" />
                                            <FilterInput title="Dydis nuo" type="number" v-model="size_from" />
                                            <FilterInput title="Dydis iki" type="number" v-model="size_to" />
                                            <!--<FilterMultiselectInput title="Dydis" label="size" v-model="size" />
                                            <FilterMultiselectInput title="Dydis arais" label="sizea" v-model="sizea" />-->
                                            <FilterInput title="Kaina už dydžio vnt. nuo" type="number" v-model="pricepera_from" />
                                            <FilterInput title="Kaina už dydžio vnt. iki" type="number" v-model="pricepera_to" />
                                             <!--<FilterMultiselectInput title="Kaina už dydžio vnt." label="pricepera"
                                                v-model="pricepera" />-->
                                            <FilterMultiselectInput title="Didelis statymas" label="bigbid"
                                                v-model="bigbid" />
                                            <FilterMultiselectInput title="Statymų kiekis" label="bids" v-model="bids" />
                                             <!--<FilterMultiselectInput title="Šalia vandens" label="water_bodies" v-model="water_bodies" />-->
                                        </div>
                                        <hr />
                                    </div>
                                </div>
                            </div>
                            <!-- END FILTERS -->
                            <!-- BEGIN RESULT -->
                            <div class="col-md-9">
                                <div class="d-flex flex-row">
                                    <h3 role="button" data-bs-toggle="collapse" data-bs-target="#resultall" aria-expanded="true"
                                        aria-controls="resultall">
                                        <i class="fa fa-file-o"></i> Rezultatai ({{ count }})
                                        <i class="fa fa-caret-down"></i>
                                    </h3>
                                </div>
                                <hr />
                                <div class="collapse" id="resultall" :class="{ show: deviceType != 'mobile'  }">
                                    <div class="padding"></div>

                                    <div class="row">
                                        <!-- BEGIN ORDER RESULT -->
                                        <div class="col-sm-6">
                                            <div class="dropdown btn-group">
                                                <button style="border-color: #ccc" class="btn btn-default dropdown-toggle"
                                                    type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                    Rikiuoti pagal<span class="caret"></span>:
                                                    {{ orderby }}
                                                </button>
                                                <ul class="dropdown-menu">
                                                    <li @click="orderby = 'Data'">
                                                        <span class="dropdown-item">Data</span>
                                                    </li>
                                                    <li @click="orderby = 'Kaina'">
                                                        <span class="dropdown-item">Kaina</span>
                                                    </li>
                                                    <li @click="orderby = 'Top'">
                                                        <span class="dropdown-item">Top</span>
                                                    </li>
                                                    <li @click="orderby = 'Dydis'">
                                                        <span class="dropdown-item">Dydis</span>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <!-- END ORDER RESULT -->
                                    </div>

                                    <!-- BEGIN TABLE RESULT -->
                                    <div class="container g-2 pt-3">
                                        <div class="row g-2 border-bottom py-3 h-100 align-items-center"
                                            v-for="r in paginated" @click="handleMarkerClicked(r)" :key="r.estate_id"
                                            :id="r.estate_id" :clickable="true" :class="{ active: r === activeEstate }">
                                            <div class="col-12 col-md-8">
                                                <div class="text-start">
                                                    <div class="row">
                                                        <div class="col-12">
                                                            <strong class="text-uppercase">{{
                                                                r.name
                                                            }} (Nr. {{ r.auction_number }})</strong>
                                                            {{ r.acution_type }}
                                                        </div>
                                                        <div class="col-12">
                                                            {{ r.subtype }} {{ r.size }} {{ r.part }}
                                                            <span v-if="r.sizea != '0' && r.part != '1/1'">({{ r.sizea }}
                                                                {{ r.size_unit }})</span>
                                                            {{ r.status }}
                                                        </div>
                                                        <div class="col-12">
                                                            {{ r.descr_formated }}
                                                        </div>
                                                        <div v-if="r.address != ''" class="col-12 pt-2">
                                                            {{ r.address }}
                                                        </div>
                                                        <div class="col-12 pt-1 pl-3">
                                                            <a style="padding-right: 10px" v-bind:href="
                                                                'https://www.evarzytynes.lt' + r.link
                                                            " target="_blank">Varžytinės</a>
                                                            <a style="padding-right: 10px" v-if="r.lt_lng != ''"
                                                                v-bind:href="
                                                                    'https://regia.lt/map/regia2?x=' +
                                                                    r.lt_lng +
                                                                    '&y=' +
                                                                    r.lt_lat +
                                                                    '&scale=1000&identify=true&sluo_ids=22'
                                                                " target="_blank">Regia</a>
                                                            <a style="padding-right: 10px" v-if="r.lt_lng != ''"
                                                                v-bind:href="
                                                                    '  https://www.geoportal.lt/map/#s=3346&x=' +
                                                                    r.lt_lng +
                                                                    '&y=' +
                                                                    r.lt_lat +
                                                                    '&l=12&b=default'
                                                                " target="_blank">Geoportal</a>
                                                            (Atnaujinta {{ r.updated }})
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-12 col-md-2">
                                                <div class="text-start">
                                                    {{ r.start_date_formated }}<br />{{
                                                        r.end_date_formated
                                                    }}
                                                </div>
                                            </div>
                                            <div class="col-12 col-md-2">
                                                <div class="price text-center mt-3">
                                                    <h5>
                                                        <b>{{ r.start_bid }}</b>€
                                                        <span v-if="r.current_bid != '0'">({{ r.current_bid }}€)</span>
                                                    </h5>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- END TABLE RESULT -->

                                    <!-- BEGIN PAGINATION -->
                                    <div class="example-six">
                                        <vue-awesome-paginate :total-items="count" v-model="current"
                                            :items-per-page="pageSize" :max-pages-shown="4">
                                            <template #prev-button>
                                                <span>
                                                    <svg xmlns="http://www.w3.org/2000/svg" fill="black" width="12"
                                                        height="12" viewBox="0 0 24 24">
                                                        <path d="M8.122 24l-4.122-4 8-8-8-8 4.122-4 11.878 12z" />
                                                    </svg>
                                                </span>
                                            </template>

                                            <template #next-button>
                                                <span>
                                                    <svg xmlns="http://www.w3.org/2000/svg" fill="black" width="12"
                                                        height="12" viewBox="0 0 24 24">
                                                        <path d="M8.122 24l-4.122-4 8-8-8-8 4.122-4 11.878 12z" />
                                                    </svg>
                                                </span>
                                            </template>
                                        </vue-awesome-paginate>
                                    </div>
                                    <!-- END PAGINATION -->
                                </div>
                                <!-- END RESULT -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- END SEARCH RESULT -->
        </div>
    </div>
</template>

  
<script >
import FilterInput from "./controls/FilterInput.vue";
import FilterMultiselectInput from "./controls/FilterMultiselectInput.vue";
import FilterDatePickerInput from "./controls/FilterDatePickerInput.vue";
import "vue-datepicker-next/index.css";
// eslint-disable-next-line
//import est_data from 'https://varzytiniuzemelapis.lt/wp-content/themes/twenty-twenty-three-child/auctionui/dist/javascriptHandler.php'


import axios from "axios";
import { ref } from 'vue'






export default {
    props: {
        auctions: Object,
    },
    components: { FilterInput, FilterMultiselectInput, FilterDatePickerInput },
    name: "App",

    data() {
        return {
            estates: [],
            infoWindowOptions: {
                pixelOffset: {
                    width: 0,
                    height: -35,
                },
                
            },
            activeEstate: {},
            infoWindowOpened: false,
            estatesfilter: "",
            part: [],
            action_type: [],
            subtype: [],
            name: [],
            size: [],
            size_unit: [],
            sizea: [],
            pricepera: [],
            bigbid: [],
            bids: [],
            start_bid_from: 0,
            start_bid_to: 0,
            size_from: 0,
            size_to: 0,
            pricepera_from: 0,
            pricepera_to: 0,
            auction_number: "",
            water_bodies:[],
            address: "",
            descr: "",
            PradziaNuoIki: [],
            PabaigaNuoIki: [],
            auction_subtype: [],
            acution_type: [],
            status: [],
            created: "",
            count: 0,
            center: { lat: 55.292028, lng: 23.970036 },
            current: 1,
            pageSize: 10,
            pagesTotal: 0,
            orderby: "Data",
            MapFilterFlats: "",
            MapFilterLand: "",
            MapFilterToday: "",
            MapFilterPart: "",
            deviceType: null,
            mapReady: false,
            lastPoli: [{ lat: 0, lng: 0 }]
        };
    },
    watch: {

        'myMapRef.map'(newValue) {
            if (newValue)
        {
                const ControlDiv = document.createElement("div");
                ControlDiv.setAttribute("class", "pe-1");
                this.addMapFilters(ControlDiv, newValue);
                // eslint-disable-next-line
                newValue.controls[google.maps.ControlPosition.TOP_RIGHT].push(ControlDiv);
                //console.log(newValue)
        }
        }

  },
    setup() {
            // eslint-disable-next-line
        const myMapRef = ref(null);
       // this.mapReady=myMapRef.value?.ready;
        return {myMapRef}
    },
    created() {
        //this.getData("https://varzytiniuzemelapis.lt/wp-content/themes/twenty-twenty-three-child/auctionui/dist/javascriptHandler.php");
        this.getData("https://varzytiniuzemelapis.lt/wp-json/auctions/v1/active_geo");
        //console.log(this.auction);
        //window.vueinstance=this;
    },
    mounted() {
        
        /*console.log(this.myMapRef );
        watch(() => [ this.myMapRef.value?.ready ], (ready) => {
            if (!ready) return;
            console.log(this.myMapRef.value.map);
            });*/
        //console.log(this.$refs.myMapRef)
        /*this.$refs.myMapRef.get((map) => {

        
            // Create the DIV to hold the control and call the CenterControl()
            // constructor passing in this DIV.
            const ControlDiv = document.createElement("div");
            ControlDiv.setAttribute("class", "pe-1");
            this.addMapFilters(ControlDiv, map);
            // eslint-disable-next-line
            map.controls[google.maps.ControlPosition.TOP_RIGHT].push(ControlDiv);
            console.log (ControlDiv);
    });*/


        this.setDeviceType();
    },
    methods: {
        clearFilter() {
            this.part = [];
            this.action_type = [];
            this.subtype = [];
            this.name = [];
            this.size = [];
            this.sizea = [];
            this.size_unit = [];
            this.pricepera = [];
            this.bigbid = [];
            this.bids = [];
            this.start_bid_from = 0;
            this.start_bid_to = 0;
            this.size_from = 0;
            this.size_to = 0;
            this.pricepera_from = 0;
            this.pricepera_to = 0;
            this.address = "";
            this.descr = "";
            this.PradziaNuoIki = [];
            this.PabaigaNuoIki = [];
            this.auction_subtype = [];
            this.acution_type = [];
            this.status = [];
            this.created = "";
            this.auction_number = "";
            this.water_bodies = [];
        },
        setDeviceType() {
            const platform = navigator.platform.toLowerCase();
            if (
                /(android|webos|iphone|ipad|ipod|blackberry|windows phone)/.test(
                    platform
                )
            ) {
                this.deviceType = "mobile";
            } else if (/mac|win|linux/i.test(platform)) {
                this.deviceType = "desktop";
            } else if (/tablet|ipad/i.test(platform)) {
                this.deviceType = "tablet";
            } else {
                this.deviceType = "unknown";
            }
        },
        // eslint-disable-next-line
        addMapFilters(controlDiv, map) {
            var e_0 = document.createElement("div");
            var e_1 = document.createElement("div");
            e_1.setAttribute("class", "dropdown");

            var e_2 = document.createElement("button");
            e_2.setAttribute("class", "btn btn-default dropdown-toggle bg-white ");
            e_2.setAttribute("type", "button");
            e_2.setAttribute("data-bs-toggle", "dropdown");
            e_2.setAttribute("aria-expanded", "false");
            var e_3 = document.createElement("i");
            e_3.setAttribute("class", "fa fa-filter pe-2");
            e_2.appendChild(e_3);
            e_2.appendChild(document.createTextNode("Filtrai\n"));
            e_1.appendChild(e_2);
            var e_4 = document.createElement("ul");
            e_4.setAttribute("class", "dropdown-menu");
            e_4.setAttribute("style", "min-width:100px");
            var e_5 = document.createElement("li");
            var e_6 = document.createElement("label");
            e_6.setAttribute("class", "ps-2");
            var e_7 = document.createElement("input");
            e_7.setAttribute("type", "checkbox");
            e_7.setAttribute("name", "MapFilterToday");
            e_6.appendChild(e_7);
            e_6.appendChild(document.createTextNode(" Šiandien"));
            e_5.appendChild(e_6);
            e_4.appendChild(e_5);

            var e_8 = document.createElement("li");
            var e_9 = document.createElement("label");
            e_9.setAttribute("class", "ps-2");
            var e_10 = document.createElement("input");
            e_10.setAttribute("type", "checkbox");
            e_10.setAttribute("name", "MapFilterLand");

            e_9.appendChild(e_10);
            e_9.appendChild(document.createTextNode(" Sklypai"));
            e_8.appendChild(e_9);
            e_4.appendChild(e_8);

            var e_11 = document.createElement("li");
            var e_12 = document.createElement("label");
            e_12.setAttribute("class", "ps-2");
            var e_13 = document.createElement("input");
            e_13.setAttribute("type", "checkbox");
            e_13.setAttribute("name", "MapFilterFlats");

            e_12.appendChild(e_13);
            e_12.appendChild(document.createTextNode(" Butai"));
            e_11.appendChild(e_12);
            e_4.appendChild(e_11);

            var e_14 = document.createElement("li");
            var e_15 = document.createElement("label");
            e_15.setAttribute("class", "ps-2");
            var e_16 = document.createElement("input");
            e_16.setAttribute("type", "checkbox");
            e_16.setAttribute("name", "MapFilterPart");

            e_15.appendChild(e_16);
            e_15.appendChild(document.createTextNode(" 1/1"));
            e_14.appendChild(e_15);
            e_4.appendChild(e_14);

            e_1.appendChild(e_4);
            e_0.appendChild(e_1);
            //created

            /*  e_7.addEventListener('click', (event) => {
              //map.setZoom(map.getZoom() + 1)
              if (event.currentTarget.checked) {
                  const date =window.vueinstance.todaysingleUI();
                  window.vueinstance.SetCreated(date);
              }
              else window.vueinstance.SetCreated(null);
              })*/

            e_7.addEventListener("click", this.HandleMapFilters);
            e_13.addEventListener("click", this.HandleMapFilters);
            e_10.addEventListener("click", this.HandleMapFilters);
            e_16.addEventListener("click", this.HandleMapFilters);
            this.MapFilterToday = e_7;
            this.MapFilterFlats = e_13;
            this.MapFilterLand = e_10;
            this.MapFilterPart = e_16;
            controlDiv.appendChild(e_0);
        },
        updateCoordinates(location) {
            this.center = {
                lat: location.latLng.lat(),
                lng: location.latLng.lng(),
            };
        },
        setCenter() {
            this.center = { lat: 55.292028, lng: 23.970036 };
        },
        getPosition(r) {
            return {
                lat: parseFloat(r.lat),
                lng: parseFloat(r.lng),
            };
        },
        getPoli1(r) {
            var ret
            if (r.poli)
            {ret=JSON.parse(r.poli).coordinates[0].reduce(function(result, item) {
                        result.push ( { lat: item[1], lng: item[0] }); 
                        return result;
                        }, []);
                        this.lastPoli=ret;   
                    }
                else ret=this.lastPoli;
            
            return ret;
        },
        getPoli(r) {
            if (!r.poli) return this.lastPoli; // jei poli nėra, grąžinam tuščią

            let g = JSON.parse(r.poli);  // paverčiam tekstą į objektą (GeoJSON)

            if (!g.coordinates) return []; // saugiklis, jei kažkas ne taip

            // Funkcija, kuri verčia vieną žiedą (masyvą koordinačių) į Google Maps formatą
            const ringToLatLng = (ring) => {
            // ring: [[lng, lat], [lng, lat], ...]
            return ring.map(([lng, lat]) => ({ lat, lng }));
            };

            if (g.type === "Polygon") {
            // g.coordinates: [ [ [lng, lat], [lng, lat], ... ] (išorinis žiedas), [ ... ] (skylės?), ... ]
            // Grąžinsim masyvą masyvų (kiekvienas elementas – žiedas).
            // Vienas poligonas su galimu vidiniu žiedu (skylių).
            this.lastPoli=g.coordinates.map(ring => ringToLatLng(ring))
            return this.lastPoli;
            }

            else if (g.type === "MultiPolygon") {
            // g.coordinates: [
            //   [ [ [lng, lat], ... ], [ ... ] ],  // poligonas #1 (išorinis + vidinis žiedas)
            //   [ [ [lng, lat], ... ] ],          // poligonas #2
            //   ...
            // ]
            // Galite atvaizduoti vienu <Polygon :paths="...">, bet tada visas išorines / vidines
            // grandines sukeliate į vieną masyvą masyvų (nors kartais geriau atvaizduoti keletą <Polygon>).

            let allRings = [];
            g.coordinates.forEach(polygon => {
                // Kiekvienas polygon yra masyvas žiedų
                polygon.forEach(ring => {
                allRings.push(ringToLatLng(ring));
                });
            });
            this.lastPoli=allRings;
            return this.lastPoli;
            }

            // Jei kiti geometrijos tipai (LineString, etc.), šiuo atveju grąžinam tuščią
            return this.lastPoli;
  },
        getData(endpont = "https://varzytiniuzemelapis.lt/wp-json/auctions/v1/active_geo") {
            axios
                .get(endpont)
                .then((response) => {
                    this.estates = response.data;
                    for (var i = 0; i < this.estates.length; i++) {
                        this.estates[i]["end_date"] = new Date(this.estates[i]["end_date"]);
                        this.estates[i]["bids"] = parseInt(this.estates[i]["bids"]);

                        if (parseInt(this.estates[i]["water_bodies"])>0)
                            this.estates[i]["water_bodies"]="Taip";
                        else
                            this.estates[i]["water_bodies"]="Ne"
                        this.estates[i]["start_date"] = new Date(
                            this.estates[i]["start_date"]
                        );
                        this.estates[i]["end_date_formated"] = this.estates[i]["end_date"].toLocaleString("lt-LT");
                        this.estates[i]["start_date_formated"] = this.estates[i]["start_date"].toLocaleString("lt-LT");
                        this.estates[i]["descr_formated"] =  this.truncate(this.estates[i]["descr"], 300) ;
                        this.estates[i]["created"] = new Date(this.estates[i]["created"]);
                        this.estates[i]["size_unit"] = (this.estates[i]["size"].match(/(a\.|kv\. m)/i) || [])[0] || null;
                        this.estates[i]["bigbid"] =
                            Math.round(
                                (parseFloat(this.estates[i]["current_bid"]) /
                                    parseFloat(this.estates[i]["start_bid"]) +
                                    Number.EPSILON) *
                                100
                            ) / 100;
                        try {
                            this.estates[i]["sizea"] = this.estates[i]["size"].includes("ha.") || this.estates[i]["size"].includes("kv.")
                                ? Math.round(
                                    ((parseFloat(
                                        this.estates[i]["size"]
                                            .match(/[0-9,]*/g)[0]
                                            .replace(",", ".")
                                    ) /
                                        parseInt(
                                            this.estates[i]["part"].match(/([0-9]+)\/([0-9]+)/)[2]
                                        )) *
                                        parseInt(
                                            this.estates[i]["part"].match(/([0-9]+)\/([0-9]+)/)[1]
                                        ) +
                                        Number.EPSILON) *
                                    100
                                ) / 100
                                : 0;
                        } catch (error) {
                            this.estates[i]["sizea"] = this.estates[i]["size"].includes("ha.")
                                ? parseFloat(
                                    this.estates[i]["size"]
                                        .match(/[0-9,]*/g)[0]
                                        .replace(",", ".")
                                )
                                : 0;
                            //console.error(error +'. '+this.estates[i]['auction_id']) ;
                        }
                        this.estates[i]["pricepera"] =
                            Math.round(
                                (this.estates[i]["start_bid"] / this.estates[i]["sizea"] +
                                    Number.EPSILON) *
                                100
                            ) / 100;
                           
                        //console.log(this.estates[i]["poli"])
                    }
                })
                //.then((response) => this.estates = response.data)
                .catch((error) => console.error(error));
        },
        handleMarkerClicked(r) {
            //var options = { year: "numeric", month: "numeric", day: "numeric" };
            //r.start_date = r.start_date.toLocaleString("lt-LT", options);
            //r.end_date = r.end_date.toLocaleString("lt-LT", options);
           // r.descr = this.truncate(r.descr, 300);
            this.activeEstate = r;
            //this.activeEstate.descr = this.truncate(r.descr, 300);
            this.infoWindowOpened = true;
        },
        handleInfoWindowClose() {
            this.activeEstate = {};
            this.infoWindowOpened = false;
        },
        test() {
            console.log("Test");
        },
        handleMapClick(e) {
            this.estates.push({
                name: "Placeholder",
                hours: "00:00am-00:00pm",
                city: "Orlando",
                state: "FL",
                latitude: e.latLng.lat(),
                longitude: e.latLng.lng(),
            });
        },
        handleInput(event) {
            console.log(event.target.value);
        },
        dateToString(value)
        {
            var options = { year: "numeric", month: "numeric", day: "numeric" };
            var ret;
            ret =value.toLocaleString("lt-LT", options);
            return ret;
        },
        thisweekStart(emit) {
            const start = new Date();
            const end = new Date();
            start.setDate(start.getDate() - start.getDay()+ (start.getDay() == 0 ? -6:1) );
            end.setDate(end.getDate() - end.getDay() +7);
            //start.setTime(start.getTime() - 7 * 24 * 3600 * 1000);
            //end.setTime(end.getTime() + 365 * 24 * 3600 * 1000);
            const date = [start, end];
            emit(date);
        },
        thisweekEnd(emit) {
            const start = new Date();
            const end = new Date();
            //start.setTime(start.getTime() - 7 * 24 * 3600 * 1000);
            end.setTime(end.getTime() + 7 * 24 * 3600 * 1000);
            const date = [start, end];
            emit(date);
        },
        today(emit) {
            const start = new Date();
            start.setHours(0, 0, 0, 0);
            const end = new Date();
            end.setHours(0, 0, 0, 0);
            end.setDate(end.getDate() + 1);
            const date = [start, end];
            emit(date);
        },
        todaysingle(emit) {
            const start = new Date();
            start.setHours(0, 0, 0, 0);
            const date = start;
            emit(date);
        },
        todaysingleUI() {
            const start = new Date();
            start.setHours(0, 0, 0, 0);
            const date = start;
            return date;
        },
        prev() {
            if (this.current > 1) this.current--;
        },
        next() {
            if (this.current < this.pagesTotal) this.current++;
        },
        truncate(value, length) {
            if (value.length > length) {
                return value.substring(0, length) + "...";
            } else {
                return value;
            }
        },
        SetSubtype(value) {
            this.subtype = value;
        },
        SetCreated(value) {
            this.created = value;
        },
        SetPart(value) {
            this.part = value;
        },
        HandleMapFilters() {
            if (this.MapFilterToday.checked) {
                const date = this.todaysingleUI();
                this.SetCreated(date);
            } else this.SetCreated(null);

            //this.SetSubtype([]);
            var arr = [];
            if (this.MapFilterLand.checked) {
                arr.push("Sklypai");
            }
            if (this.MapFilterFlats.checked) {
                arr.push("Patalpos/Butai");
            }
            this.SetSubtype(arr);
            if (this.MapFilterPart.checked) {
                this.SetPart(["1/1"]);
            } else this.SetPart([]);
        },
    },
    computed: {
        mapCenter() {
            if (!this.estates.length) {
                return {
                    lat: 55.292028,
                    lng: 23.970036,
                };
            }

            return {
                /*lat: parseFloat(this.estates[0].lat),
                    lng: parseFloat(this.estates[0].lng)]*/
                lat: 55.292028,
                lng: 23.970036,
            };
        },
        infoWindowPosition() {
            return {
                lat: parseFloat(this.activeEstate.lat),
                lng: parseFloat(this.activeEstate.lng),
            };
        },
        autocomplete() {
            var filt = this.estates.slice();
            if (this.part.length > 0) {
                filt = filt.filter((v) => this.part.includes(v.part));
            }
            if (this.acution_type.length > 0) {
                //filt=filt.filter(v => v.acution_type == this.action_type)
                filt = filt.filter((v) => this.acution_type.includes(v.acution_type));
            }
            if (this.subtype.length > 0) {
                filt = filt.filter((v) => this.subtype.includes(v.subtype));
            }
            if (this.name.length > 0) {
                filt = filt.filter((v) => this.name.includes(v.name));
            }
            if (this.size.length > 0) {
                filt = filt.filter((v) => this.size.includes(v.size));
            }
            if (this.start_bid_from > 0) {
                filt = filt.filter((v) => v.start_bid >= Number(this.start_bid_from));
            }
            if (this.start_bid_to > 0) {
                filt = filt.filter((v) => v.start_bid <= Number(this.start_bid_to));
            }

            if (this.pricepera_from > 0) {
                filt = filt.filter((v) => v.pricepera >= Number(this.pricepera_from));
            }
            if (this.pricepera_to > 0) {
                filt = filt.filter((v) => v.pricepera <= Number(this.pricepera_to));
            }
            
            if (this.size_to > 0) {
                filt = filt.filter((v) => v.sizea <= Number(this.size_to));
            }
            if (this.size_from > 0) {
                filt = filt.filter((v) => v.sizea >= Number(this.size_from));
            }

            if (this.descr != "") {
                filt = filt.filter((v) =>
                    v.descr.toLowerCase().includes(this.descr.toLowerCase())
                );
            }
            if (this.auction_number != "") {
                filt = filt.filter((v) =>
                    v.auction_number.toLowerCase().includes(this.auction_number.toLowerCase())
                );
            }
            if (this.water_bodies.length > 0) {
                filt = filt.filter((v) => this.water_bodies.includes(v.water_bodies));
            }
            
            if (this.address != "") {
                filt = filt.filter((v) =>
                    v.address.toLowerCase().includes(this.address.toLowerCase())
                );
            }
            if (
                this.PabaigaNuoIki.length > 0 &&
                this.PabaigaNuoIki[0] != "" &&
                this.PabaigaNuoIki[1] != "" &&
                this.PabaigaNuoIki[0] != null &&
                this.PabaigaNuoIki[1] != null
            ) {
                filt = filt.filter(
                    (v) =>
                        v.end_date >= this.PabaigaNuoIki[0] &&
                        v.end_date <= this.PabaigaNuoIki[1]
                );
            }
            if (
                this.PradziaNuoIki.length > 0 &&
                this.PradziaNuoIki[0] != "" &&
                this.PradziaNuoIki[1] != "" &&
                this.PradziaNuoIki[0] != null &&
                this.PradziaNuoIki[1] != null
            ) {
                filt = filt.filter(
                    (v) =>
                        v.start_date >= this.PradziaNuoIki[0] &&
                        v.start_date <= this.PradziaNuoIki[1]
                );
            }
            if (this.created != "" && this.created != null) {
                filt = filt.filter((v) => v.created >= this.created);
            }
            if (this.sizea.length > 0) {
                filt = filt.filter((v) => this.sizea.includes(v.sizea));
            }
            if (this.size_unit.length > 0) {
                filt = filt.filter((v) => this.size_unit.includes(v.size_unit));
            }

            
            if (this.pricepera.length > 0) {
                filt = filt.filter((v) => this.pricepera.includes(v.pricepera));
            }
            if (this.bigbid.length > 0) {
                filt = filt.filter((v) => this.bigbid.includes(v.bigbid));
            }
            if (this.bids.length > 0) {
                filt = filt.filter((v) => this.bids.includes(v.bids));
            }
            if (this.auction_subtype.length > 0) {
                filt = filt.filter((v) =>
                    this.auction_subtype.includes(v.auction_subtype)
                );
            }
            if (this.status.length > 0) {
                filt = filt.filter((v) => this.status.includes(v.status));
            }
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.count = filt.length;
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.current = 1;
            if (this.orderby == "Kaina") {
                filt = filt.sort(
                    (a, b) => parseFloat(a.start_bid) - parseFloat(b.start_bid)
                );
            } 
            else if (this.orderby == "Top") 
            {

                filt = filt.sort(
                    (a, b) => parseFloat(b.bigbid) - parseFloat(a.bigbid)
                );
            }
            else if (this.orderby == "Dydis") 
            {

                filt = filt.sort(
                    (a, b) => parseFloat(b.sizea) - parseFloat(a.sizea)
                );
            }
            return filt;
        },
        unique() {
            return function (arr, key) {
               // arr=arr.filter(x => x !== null)
                arr = arr.filter((v) => v[key]!== null && v[key]!=="");
                var output = [];
                var usedKeys = {};
                for (var i = 0; i < arr.length; i++) {
                    if (!usedKeys[arr[i][key]]) {
                        usedKeys[arr[i][key]] = true;
                        output.push(arr[i]);
                    }
                }
                function compare(a, b) {
                    if (a[key] < b[key]) return -1;
                    if (a[key] > b[key]) return 1;
                    return 0;
                }
                return output.sort(compare);
            };
        },
        indexStart() {
            return (this.current - 1) * this.pageSize;
        },
        indexEnd() {
            return this.indexStart + this.pageSize;
        },
        paginated() {
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.pagesTotal = Math.ceil(this.count / this.pageSize);
            return this.autocomplete.slice(this.indexStart, this.indexEnd);
        },
        maplist() {
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties

            return this.autocomplete.filter((v) => v.lat != null && v.lat !== '');
        },
        customFilter() {
            return function (option, query, select) {
                console.log(option);
                console.log(query);
                console.log(select);
                return null;
            };
        }
    },
};
</script>
  
<style>
.filter_list {
    margin-bottom: 2rem;
}

.filter {
    padding-left: 1rem;
}

.filter>input,
.filter>div>input,
.filter>div>input:focus-visible,
.filter>input:focus-visible {
    width: 100%;
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 4px;
    outline: 0;
    padding-left: 10px;
}

.auction>td>a {
    margin-right: 10px;
}

.info-window>p {
    margin: 0px;
}

.info-window>h3 {
    font-size: 1rem;
}

.auctions_list {
    display: flex;
    flex-wrap: wrap;
    margin: 10px;
    justify-content: center;
}

.auction {
    /*box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.5);*/
    border-top: 1px solid #ccc;
    margin-top: 10px;
    padding: 10px;
    width: 96%;
    flex-grow: 0;
    text-align: start;
}

.title,
.control {
    font-size: 15px;
    font-weight: 200;
}

.control {
    min-height: 40px;
}

.active {
    background-color: bisque;
}

.footer {
    height: 20px;
}

.card-body {
    padding: 0px !important;
    margin: 2px !important;
    /*    align-items: center;*/
}

.btn {
    margin-top: 10px !important;
}

.mx-datepicker-range,
.mx-datepicker {
    width: 100% !important;
}

.mx-input {
    min-height: 40px;
}

.example-six .pagination-container {
    column-gap: 0px;
    align-items: center;
}

.example-six .paginate-buttons {
    height: 35px;
    width: 35px;
    cursor: pointer;
    border-radius: 4px;
    background-color: transparent;
    border: none;
    color: black;
    text-align: center;
    padding: 0px;
}

.example-six .back-button,
.example-six .next-button {
    background-color: white;
    color: white;
    border-radius: 8px;
    height: 45px;
    width: 45px;
}

.example-six .active-page {
    background-color: #e5e5e5;
}

.example-six .paginate-buttons:hover {
    background-color: #f5f5f5;
}

.example-six .active-page:hover {
    background-color: #e5e5e5;
}

.example-six .back-button svg {
    transform: rotate(180deg) translateY(-2px);
}

.example-six .next-button svg {
    transform: translateY(2px);
}

.example-six .back-button:hover,
.example-six .next-button:hover {
    background-color: rgb(45, 45, 45);
}

.example-six .back-button:active,
.example-six .next-button:active {
    background-color: rgb(85, 85, 85);
}

.open-filters {
    font-size: 120%;
    content: "\f15c";
}

.filter_list>h4 {
    padding-left: 10px;
}

/*new layout*/

body {
    /*margin-top: 25px;*/
    background: #eee;
}

.btn {
    margin-bottom: 5px;
}

.grid {
    position: relative;
    width: 100%;
    background: #fff;
    color: #666666;
    border-radius: 2px;
    margin-bottom: 5px;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.1);
}

.grid .grid-body {
    padding: 15px 20px 15px 20px;
    font-size: 0.9em;
    line-height: 1.9em;
}

.search table tr td.rate {
    color: #f39c12;
    line-height: 50px;
}

.search table tr:hover {
    cursor: pointer;
}

.search table tr td.image {
    width: 50px;
}

.search table tr td img {
    width: 50px;
    height: 50px;
}

.search table tr td.rate {
    color: #f39c12;
    line-height: 50px;
}

.search table tr td.price {
    font-size: 1.5em;
    line-height: 50px;
}

.search #price1,
.search #price2 {
    display: inline;
    font-weight: 600;
}

.row>.col-md-6:last-child:nth-child(odd) {
    width: 100%;
}

@media (min-width: 768px) {
    .collapse.dont-collapse-sm {
        display: block !important;
        height: auto !important;
        visibility: visible;
    }
}

.btn {
    border-color: rgb(204, 204, 204);
}

.multiselect-tag {
    white-space: unset!important;
}

.nav-link, .nav-link:hover {
    color: #666666!important;
}
.main-container {
    height: 100vh;
}
@import 'https://maxcdn.bootstrapcdn.com/font-awesome/4.3.0/css/font-awesome.min.css';
</style>

<style src="@vueform/multiselect/themes/default.css"></style>

<style>
@import "@vueform/multiselect/themes/default.css";
</style>